import React from "react";

// Auth Imports
import SignIn from "views/auth/SignIn";
import { AiOutlineLogout } from 'react-icons/ai';
import SignOut from "views/auth/SignOut";


const routes = [

  {
    name: "Log In",
    layout: "/auth",
    path: "sign-in",
    display: "hidden",
    icon: <AiOutlineLogout className="h-6 w-6" />,
    component: <SignIn />,
  },
  {
    name: "Log Out",
    layout: "/auth",
    path: "sign-out",
    display: "",
    icon: <AiOutlineLogout className="h-6 w-6" />,
    component: <SignOut />,
  },
 
];
export default routes;
